export function normalizeUserEmailFilter(email: string): string {
  return email.trim().toLowerCase();
}
